import { Button } from "@/components/ui/button";
import { Activity, ArrowRight, Clock, Package } from "lucide-react";
import React from "react";

const ExpiryPendingRxCard: React.FC = () => {
    return (
        <div className="flex flex-col items-start justify-start w-full border border-gray-200 rounded-xl">
            <div className="flex flex-row items-center justify-start gap-x-2 w-full py-2 px-4">
                <Activity className="text-gray-500 h-5 w-5"/>
                <span className="text-sm text-gray-500 font-normal">Expiry and Pending RX</span>
            </div>
            <div className="w-full border-[0.2px] border-gray-300" />
            <div className="w-full p-4 flex flex-col gap-y-3">
                {/* Pending Card */}
                <div className="w-full bg-orange-50 border border-orange-100 rounded-lg p-4 flex flex-row items-center justify-between">
                    <div className="flex flex-row items-center gap-x-3">
                        <div className="bg-orange-100 rounded-full p-2">
                            <Clock className="h-5 w-5 text-orange-600" />
                        </div>
                        <div className="flex flex-col">
                            <span className="text-sm font-medium text-gray-900">Pending</span>
                            <span className="text-xs text-gray-500">Awaiting review</span>
                        </div>
                    </div>
                    <span className="text-2xl font-semibold text-orange-600">8</span>
                </div>

                {/* Ready Card */}
                <div className="w-full bg-blue-50 border border-blue-100 rounded-lg p-4 flex flex-row items-center justify-between">
                    <div className="flex flex-row items-center gap-x-3">
                        <div className="bg-blue-100 rounded-full p-2">
                            <Package className="h-5 w-5 text-blue-600" />
                        </div>
                        <div className="flex flex-col">
                            <span className="text-sm font-medium text-gray-900">Ready</span>
                            <span className="text-xs text-gray-500">For pickup</span>
                        </div>
                    </div>
                    <span className="text-2xl font-semibold text-blue-600">8</span>
                </div>

                {/* Refills Card */}
                <div className="w-full bg-green-50 border border-green-100 rounded-lg p-4 flex flex-row items-center justify-between">
                    <div className="flex flex-row items-center gap-x-3">
                        <div className="bg-green-100 rounded-full p-2">
                            <svg className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-sm font-medium text-gray-900">Refills</span>
                            <span className="text-xs text-gray-500">Due today</span>
                        </div>
                    </div>
                    <span className="text-2xl font-semibold text-green-600">5</span>
                </div>

                {/* View All Button */}
                <Button variant="outline" className="w-full justify-center text-sm mt-2">
                    View All Prescriptions <ArrowRight className="ml-1 h-4 w-4" />
                </Button>
            </div>
        </div>
    );
}

export default ExpiryPendingRxCard;
